export const SNACKBAR_VARIANTS = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
} as const

export const CLOSE_SNACKBAR_TIME_MS = 3000
export const OLD_NOTIFICATIONS_SNACKBAR_TIME_MS = 5000
